import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';
import { MessageInfoComponent } from '../../user/cards/create-message-info/create-message-info.component';

@Component({
  selector: 'app-info-help',
  standalone: false,
  template: `
    <span (click)="openHelp()" class="help-icon" aria-label="Pomoc">
      <mat-icon>info</mat-icon>
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app.help.info.component.scss']
})
export class AppHelpInfoComponent {
  @Input() pageId!: number | string;
  @Input() title!: string;

  constructor(private dialog: MatDialog) {}

  openHelp(): void {
    this.dialog.open(DialogConfirmComponent, {
      width: '95vw',
      minWidth: '60vw',
      maxHeight: '70vh',
      data: {
        title: this.title || 'Informacja',
        messageComponent: MessageInfoComponent,
        pageId: this.pageId,
        hideCancel: true,
        okLabel: 'Zamknij'
      }
    });
  }
}



